<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Upload doc"
      ><i class="las la-file-alt text-primary fs-1100"></i
    ></a>

    <b-modal ref="userModal" size="xl" hide-footer title="Documents Upload">
      <div class="d-block">
        <div class="row mt-3 mb-5">
          <div class="col-xl-4 col-lg-4 col-md-4 col-12">
            <h5 class="mb-0 text-dark-light pb-2">Dealership Docs</h5>
            <div class="pb-3">
              <div class="tag-input files-columns">
                <template v-for="(image, index) in getDealerShipDocs">
                  <div :key="index">
                    <div class="tag-input__tag">
                      <div v-if="image.fileName">
                        <span
                          ><a :href="`${image.url}`" target="_blank"
                            ><span v-if="image.aliasName">{{
                              image.aliasName
                            }}</span>
                            <span v-else>Doc - {{ index + 1 }}</span></a
                          >
                        </span>
                        <span @click="fnDocumentRemove(image.id)" class="pl10"
                          ><i class="far fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                    <span
                      class=""
                      v-b-tooltip.right="'Change file name'"
                      @click="fnOpenModalDocumentAliasName(image.id)"
                    >
                      <i class="las la-pen mt1200"></i>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-12">
            <h5 class="mb-0 text-dark-light pb-2">VSA Docs</h5>
            <div class="pb-3">
              <div class="tag-input files-columns">
                <template v-for="(image, index) in getAdminDocs">
                  <div :key="index">
                    <div class="tag-input__tag">
                      <div v-if="image.fileName">
                        <span
                          ><a :href="`${image.url}`" target="_blank"
                            ><span v-if="image.aliasName">{{
                              image.aliasName
                            }}</span>
                            <span v-else>VSA Doc - {{ index + 1 }}</span></a
                          >
                        </span>
                        <span @click="fnDocumentRemove(image.id)" class="pl10"
                          ><i class="far fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                    <span
                      class=""
                      v-b-tooltip.right="'Change file name'"
                      @click="fnOpenModalDocumentAliasName(image.id)"
                    >
                      <i class="las la-pen mt1200"></i>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-12">
            <!-- Select the file upload section either VSA or Dealer -->
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_title"
                placeholder=" "
                :options="optionDocType"
                v-model="docTypeId"
              ></b-form-select>
              <label class="floatingLabel" for="title"
                >Select document for VSA / Dealer</label
              >
            </div>

            <div v-if="docTypeId">
              <vue-dropzone
                ref="docUploadDropzone"
                id="docUploadDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptions"
                v-on:vdropzone-sending="fnSendingDocuemtAdmin"
                @vdropzone-queue-complete="fnAfterSendingDocuemtAdmin"
                class="quoteDocUpload"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">
                    <i class="las la-cloud-upload-alt fs-2000 text-info"></i>
                  </div>
                  <h5 class="dropzone-custom-title">
                    Drag and drop to upload file!
                  </h5>
                  <div class="subtitle">
                    ...or click to select a file from your computer
                  </div>
                  <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                  <span v-if="loading">Uploading...</span>
                </div>
              </vue-dropzone>
            </div>
          </div>
        </div>
        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-dark btn-sm mr-2"
            @click="hideModal"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <appModalDocumentAliasName
      ref="modalDocumentAliasName"
      :documentId="documentId"
      :quoteId="quoteId"
    ></appModalDocumentAliasName>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as authService from '../../services/auth.service'
import * as clientDocumentService from '../../services/clientDocument.service'
import store from '../../store/modules/base.module'
import vueDropzone from 'vue2-dropzone'
import appModalDocumentAliasName from './ModalDocumentAliasName.vue'

export default {
  name: 'ModalDocumentsUpload',
  props: ['quoteId', 'quoteType'],
  components: {
    vueDropzone,
    appModalDocumentAliasName
  },
  data() {
    return {
      errors: {},
      serverPath: store.state.serverPath,
      documentId: '',
      dropzoneOptions: {
        url: `${store.state.apiURL}/client-document/upload`,
        headers: {
          Authorization: `Bearer ${authService.getAccessToken()}`
        },
        thumbnailWidth: 75,
        maxFilesize: 20,
        uploadMultiple: true,
        maxFiles: 10,
        paralleUploads: 10,
        previewsContainer: false,
        acceptedFiles: '.pdf, .docx, .doc, .xlsx, .xls, .jpg, .jpeg, .png'
      },
      loading: false,
      optionDocType: [
        { text: 'VSA', value: 11 },
        { text: 'Dealer', value: 10 }
      ],
      docTypeId: ''
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle']),
    getDealerShipDocs() {
      if (this.getQuoteSingle.client_documents) {
        let client_documents = this.getQuoteSingle.client_documents

        let docs = client_documents.filter(function (doc) {
          return doc.documentTypeId == 10
        })

        return docs
      }
    },
    getAdminDocs() {
      if (this.getQuoteSingle.client_documents) {
        let client_documents = this.getQuoteSingle.client_documents

        let docs = client_documents.filter(function (doc) {
          return doc.documentTypeId == 11
        })

        return docs
      }
    }
  },
  methods: {
    ...mapActions(['fetchQuoteSingle']),
    fnShowModal() {
      this.fetchQuoteSingle({id:this.quoteId, quoteType:this.quoteType})
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    // Dropzone docuemt upload by Admins
    fnSendingDocuemtAdmin(file, xhr, formData) {
      this.loading = true
      formData.append('quoteId', this.quoteId)
      formData.append('documentTypeId', this.docTypeId)
    },
    // Dropzone docuemt upload after Admins
    fnAfterSendingDocuemtAdmin(file) {
      this.fetchQuoteSingle({id:this.quoteId, quoteType:this.quoteType})
      this.loading = false
    },
    // Document remove in file storage and database
    fnDocumentRemove: async function (id) {
      try {
        const response = await clientDocumentService.documentRemove(id)
        this.errors = {}

        this.fetchQuoteSingle({id:this.quoteId, quoteType:this.quoteType})

        messageService.fnSweetAlertSuccessToast(
          'Document removed',
          response.data.message
        )
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Document removed',
          'Something wrong, please try again!'
        )
      }
    },
    fnOpenModalDocumentAliasName(documentId) {
      this.documentId = documentId
      this.$refs.modalDocumentAliasName.fnShowModal()
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.files-columns {
  overflow-y: scroll;
  min-height: 300px;
}
</style>